import "./PartnersSection.css";
import partner1 from "../../assets/images/partner1.png";
import partner2 from "../../assets/images/partner2.png";
import partner3 from "../../assets/images/partner3.png";
import partner4 from "../../assets/images/partner4.png";
import partner5 from "../../assets/images/partner5.png";
import partner6 from "../../assets/images/partner6.png";
import partner7 from "../../assets/images/partner7.png";
import partner8 from "../../assets/images/partner8.png";


export default function PartnersSection() {
  const partners = [
    { src: partner1, alt: "Partner 1" },
    { src: partner2, alt: "Partner 2" },
    { src: partner3, alt: "Partner 3" },
    { src: partner4, alt: "Partner 4" },
    { src: partner5, alt: "Partner 5" },
    { src: partner6, alt: "Partner 6" },
    { src: partner7, alt: "Partner 7" },
    { src: partner8, alt: "Partner 8" },
  ];

  return (
    <section id="section5" className="partners-section">
      <div className="partners-container">
        <div className="partners-text">
          <p>
            Αναζητούμε συνεργασίες με επιχειρήσεις που ευθυγραμμίζονται
            πραγματικά με τη φιλοσοφία μας. Οι συνεργάτες μας συμβάλλουν στην
            προσέλκυση διαφορετικών κοινού, στη δημιουργία δικτύων, στην
            ανάπτυξη νέων πρωτοβουλιών και στην ενίσχυση της συνολικής εμπειρίας
            του φεστιβάλ.
          </p>
        </div>
        <h2 className="partners-heading">Partners</h2>
        <div className="partners-logos">
          {partners.map((partner, index) => (
            <img key={index} src={partner.src} alt={partner.alt} />
          ))}
        </div>
      </div>
    </section>
  );
}